/* eslint-disable max-len */
import React, { ReactElement } from 'react'

/**
 * QCS sidebar mark — PLACEHOLDER.
 *
 * This is a neutral "QCS" wordmark set in the interface typeface, not the real
 * Quality Compliance Systems logo. Redrawing a company's actual mark by eye from
 * a screenshot produces something subtly wrong that then ships as if it were the
 * brand, so this deliberately does not attempt it.
 *
 * To use the real one: drop the supplied SVG in beside this file and replace the
 * body below. Nothing else needs to change — `Menu.js` already picks the mark by
 * brand.
 */
export const QcsLogo = (): ReactElement => {
  return (
    <svg
      width="44"
      height="34"
      viewBox="0 0 44 34"
      fill="none"
      role="img"
      aria-label="QCS"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="43" height="33" rx="6" fill="#FFFFFF" />
      <text
        x="22"
        y="23"
        textAnchor="middle"
        fontFamily="Lato, 'Segoe UI', Helvetica, Arial, sans-serif"
        fontSize="15"
        fontWeight="700"
        letterSpacing="0.6"
        fill="#0F3D3C">
        QCS
      </text>
    </svg>
  )
}

export default QcsLogo
